<template>
  <div>
    <supervision_app_bar/>
      <v-container fluid>

    <!-- ==================== TOP HEADER BAR ==================== -->
    <v-card class="rounded-0 mt-15 header-bar pa-5" color="white">
      <div>
        <h2 class="page-title">ระบบกำกับติดตาม คัดเลือกศึกษานิเทศก์ สอศ.</h2>
        <p class="page-subtitle mb-0">
          ประจำปี {{ period_supervisor.period_sedirector_year || '-' }} ครั้งที่
          {{ period_supervisor.period_sedirector_times || '-' }}
        </p>
      </div>
      <v-spacer></v-spacer>
      <v-chip small color="#1565c0" dark class="mr-3 chip-period">
        <v-icon left small>mdi-calendar-check</v-icon>
        รับสมัคร :
        {{
          period_supervisor.period_sedirector_start
            | moment("add", "543 years")
            | moment("D MMM YYYY")
        }}
        —
        {{
          period_supervisor.period_sedirector_stop
            | moment("add", "543 years")
            | moment("D MMM YYYY")
        }}
      </v-chip>
    </v-card>

    <!-- ==================== TAB NAVIGATION ==================== -->
    <v-card flat class="px-4 pt-1 pb-0" color="#fafbfc" style="border-bottom: 1px solid #e8ecf1;">
      <v-tabs v-model="currentTab" color="#1565c0" slider-color="#1565c0" background-color="transparent">
        <v-tab v-for="tab in tabs" :key="tab.value" class="text-none tab-item">
          <v-icon left small>{{ tab.icon }}</v-icon>
          {{ tab.title }}
          <v-badge
            v-if="tab.badge"
            :content="tab.badge"
            color="#e53935"
            inline
            class="ml-1"
          ></v-badge>
        </v-tab>
      </v-tabs>
    </v-card>

    <!-- ==================== TAB: DASHBOARD ==================== -->
    <v-tabs-items v-model="currentTab" class="tab-content-area">
      <v-tab-item>
        <v-container fluid class="pa-5">
          <!-- Stats Cards -->
          <v-row>
            <v-col cols="12" sm="6" md="3" v-for="(stat, idx) in statsCards" :key="idx">
              <v-card flat class="stat-card rounded-lg" :style="{ borderTop: '3px solid ' + stat.color }">
                <div class="pa-4">
                  <div class="d-flex justify-space-between align-start">
                    <div>
                      <div class="stat-card-label">{{ stat.title }}</div>
                      <div class="stat-card-value" :style="{ color: stat.color }">{{ stat.value }}</div>
                      <div class="stat-card-sub">{{ stat.sub }}</div>
                    </div>
                    <v-avatar :color="stat.color" size="44" class="stat-icon-avatar">
                      <v-icon color="white" size="22">{{ stat.icon }}</v-icon>
                    </v-avatar>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <!-- Charts -->
          <v-row class="mt-2">
            <v-col cols="12" md="8">
              <v-card flat class="rounded-lg card-white">
                <v-card-title class="card-header">
                  <div>
                    <div class="card-title-text">สถิติการสมัครรายวัน</div>
                    <div class="card-subtitle-text">ข้อมูลย้อนหลัง</div>
                  </div>
                  <v-spacer></v-spacer>
                  <v-btn-toggle v-model="chartPeriod" mandatory dense class="period-toggle">
                    <v-btn small text value="7d">7 วัน</v-btn>
                    <v-btn small text value="14d">14 วัน</v-btn>
                    <v-btn small text value="30d">30 วัน</v-btn>
                  </v-btn-toggle>
                </v-card-title>
                <v-card-text>
                  <canvas ref="dailyChart" height="260"></canvas>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="4">
              <v-card flat class="rounded-lg card-white">
                <v-card-title class="card-header">
                  <div>
                    <div class="card-title-text">สถานะใบสมัคร</div>
                    <div class="card-subtitle-text">ภาพรวมทั้งหมด</div>
                  </div>
                </v-card-title>
                <v-card-text>
                  <canvas ref="statusChart" height="230"></canvas>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <!-- Region & Recent -->
          <v-row class="mt-2">
            <v-col cols="12" md="5">
              <v-card flat class="rounded-lg card-white">
                <v-card-title class="card-header">
                  <div class="card-title-text">สถิติตามภูมิภาค</div>
                </v-card-title>
                <v-card-text>
                  <canvas ref="regionChart" height="250"></canvas>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="7">
              <v-card flat class="rounded-lg card-white">
                <v-card-title class="card-header">
                  <div class="card-title-text">ใบสมัครล่าสุด</div>
                  <v-spacer></v-spacer>
                  <v-btn text small color="#1565c0" @click="currentTab = 1">
                    ดูทั้งหมด <v-icon small right>mdi-arrow-right</v-icon>
                  </v-btn>
                </v-card-title>
                <v-simple-table class="white-table">
                  <thead>
                    <tr>
                      <th>เลขที่</th>
                      <th>ชื่อ-สกุล</th>
                      <th>สถานศึกษา</th>
                      <th>สถานะ</th>
                      <th>วันที่</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="app in recentApps" :key="app.supervisor_app_id">
                      <td class="font-weight-medium">{{ app.supervisor_app_idno || '-' }}</td>
                      <td>{{ app.supervisor_app_fristnames }}</td>
                      <td class="text-truncate" style="max-width:160px;">{{ app.supervisor_app_user_firstname }}</td>
                      <td>
                        <v-chip
                          :color="getStatusColor(app.supervisor_app_status)"
                          x-small
                          dark
                          class="font-weight-bold"
                        >{{ getStatusText(app.supervisor_app_status) }}</v-chip>
                      </td>
                      <td class="grey--text text--darken-1 text-caption">{{ formatDate(app.supervisor_app_created_at) }}</td>
                    </tr>
                    <tr v-if="recentApps.length === 0">
                      <td colspan="5" class="text-center grey--text pa-6">ยังไม่มีข้อมูลใบสมัคร</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>

      <!-- ==================== TAB: APPLICATION LIST ==================== -->
      <v-tab-item>
        <v-container fluid class="pa-5">
          <v-card flat class="rounded-lg card-white">
            <v-card-title class="card-header pb-2">
              <div>
                <div class="card-title-text">รายการใบสมัครทั้งหมด</div>
                <div class="card-subtitle-text">จัดการและตรวจสอบข้อมูลผู้สมัคร</div>
              </div>
              <v-spacer></v-spacer>
              <v-btn color="#2e7d32" dark small class="mr-2 text-none btn-action" @click="exportExcel()">
                <v-icon left small>mdi-file-excel</v-icon> Export
              </v-btn>
              <v-btn outlined small class="text-none btn-action" @click="loadApplications()">
                <v-icon left small>mdi-refresh</v-icon> รีเฟรช
              </v-btn>
            </v-card-title>

            <!-- Filters -->
            <v-card-text class="pb-0">
              <v-row dense>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="filters.search"
                    placeholder="ค้นหาชื่อ, เลขบัตร, เลขที่สมัคร..."
                    prepend-inner-icon="mdi-magnify"
                    outlined dense hide-details clearable
                    background-color="#f8f9fb"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                  <v-select
                    v-model="filters.status"
                    :items="statusFilterItems"
                    label="สถานะ"
                    outlined dense hide-details clearable
                    background-color="#f8f9fb"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="2">
                  <v-select
                    v-model="filters.approve"
                    :items="approveFilterItems"
                    label="ผลอนุมัติ"
                    outlined dense hide-details clearable
                    background-color="#f8f9fb"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="2">
                  <v-select
                    v-model="filters.region"
                    :items="regionFilterItems"
                    label="ภูมิภาค"
                    outlined dense hide-details clearable
                    background-color="#f8f9fb"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-menu v-model="dateRangeMenu" :close-on-content-click="false" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="filters.dateRange"
                        label="ช่วงวันที่สมัคร"
                        prepend-inner-icon="mdi-calendar-range"
                        readonly outlined dense hide-details clearable
                        background-color="#f8f9fb"
                        v-bind="attrs" v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="filters.dateRange" range></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-card-text>

            <!-- Data Table -->
            <v-data-table
              :headers="appHeaders"
              :items="filteredApplications"
              :loading="loadingApps"
              :items-per-page="15"
              :footer-props="{ 'items-per-page-options': [10, 15, 25, 50, -1] }"
              class="white-data-table"
              show-select
              v-model="selectedApps"
            >
              <template v-slot:item.supervisor_app_fristnames="{ item }">
                <div class="d-flex align-center py-2">
                  <v-avatar size="30" color="#e3f2fd" class="mr-2">
                    <span class="blue--text text--darken-2 text-caption font-weight-bold">
                      {{ (item.supervisor_app_fristnames || '?').charAt(0) }}
                    </span>
                  </v-avatar>
                  <div>
                    <div class="font-weight-medium text-body-2">{{ item.supervisor_app_fristnames }}</div>
                    <div class="text-caption grey--text">{{ item.supervisor_app_idcard }}</div>
                  </div>
                </div>
              </template>

              <template v-slot:item.supervisor_app_status="{ item }">
                <v-chip :color="getStatusColor(item.supervisor_app_status)" x-small dark class="font-weight-bold">
                  {{ getStatusText(item.supervisor_app_status) }}
                </v-chip>
              </template>

              <template v-slot:item.supervisor_app_approve="{ item }">
                <v-chip v-if="item.supervisor_app_approve === 'pass'" color="#2e7d32" x-small dark>ผ่าน</v-chip>
                <v-chip v-else-if="item.supervisor_app_approve === 'fail'" color="#c62828" x-small dark>ไม่ผ่าน</v-chip>
                <span v-else class="text-caption grey--text">รอตรวจสอบ</span>
              </template>

              <template v-slot:item.supervisor_app_created_at="{ item }">
                <span class="text-caption grey--text text--darken-1">{{ formatDate(item.supervisor_app_created_at) }}</span>
              </template>

              <template v-slot:item.actions="{ item }">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn icon x-small class="mr-1" @click="viewApplication(item)" v-on="on" color="#1565c0">
                      <v-icon size="18">mdi-eye-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>ดูรายละเอียด</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn icon x-small class="mr-1" @click="openApproveDialog(item)" v-on="on" color="#2e7d32">
                      <v-icon size="18">mdi-check-decagram</v-icon>
                    </v-btn>
                  </template>
                  <span>อนุมัติ</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn icon x-small @click="openPrintDialog(item.supervisor_app_idref)" v-on="on" color="#ef6c00">
                      <v-icon size="18">mdi-printer-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>พิมพ์ใบสมัคร</span>
                </v-tooltip>
              </template>
            </v-data-table>

            <!-- Bulk Actions -->
            <v-slide-y-transition>
              <v-card-actions v-if="selectedApps.length > 0" class="pa-4 bulk-bar">
                <v-icon small class="mr-2" color="#1565c0">mdi-checkbox-multiple-marked</v-icon>
                <span class="text-body-2 mr-4">เลือก <strong>{{ selectedApps.length }}</strong> รายการ</span>
                <v-btn small color="#2e7d32" dark @click="bulkApprove('pass')" class="mr-2 text-none">
                  <v-icon left small>mdi-check-all</v-icon> อนุมัติทั้งหมด
                </v-btn>
                <v-btn small color="#c62828" dark @click="bulkApprove('fail')" class="text-none">
                  <v-icon left small>mdi-close-circle</v-icon> ไม่อนุมัติทั้งหมด
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn small text @click="selectedApps = []">ยกเลิกเลือก</v-btn>
              </v-card-actions>
            </v-slide-y-transition>
          </v-card>
        </v-container>
      </v-tab-item>

      <!-- ==================== TAB: APPLICATION DETAIL ==================== -->
      <v-tab-item>
        <v-container fluid class="pa-5">
          <v-btn text small class="mb-3 text-none" color="#1565c0" @click="currentTab = 1">
            <v-icon left small>mdi-arrow-left</v-icon> กลับไปรายการ
          </v-btn>

          <v-row>
            <!-- Left: Info -->
            <v-col cols="12" md="8">
              <v-card flat class="rounded-lg card-white pa-5">
                <div class="d-flex justify-space-between align-center mb-4">
                  <div>
                    <div class="card-title-text">ข้อมูลผู้สมัคร</div>
                    <div class="card-subtitle-text">รหัสอ้างอิง: {{ selectedApp.supervisor_app_idref }}</div>
                  </div>
                  <v-chip :color="getStatusColor(selectedApp.supervisor_app_status)" dark small>
                    {{ getStatusText(selectedApp.supervisor_app_status) }}
                  </v-chip>
                </div>

                <!-- Personal Info -->
                <div class="detail-section">
                  <div class="detail-section-title">
                    <v-icon small color="#1565c0" class="mr-1">mdi-account-outline</v-icon>
                    ข้อมูลส่วนตัว
                  </div>
                  <v-row dense class="mt-2">
                    <v-col cols="6" md="4">
                      <div class="detail-label">ชื่อ-สกุล</div>
                      <div class="detail-value">{{ selectedApp.supervisor_app_fristnames }}</div>
                    </v-col>
                    <v-col cols="6" md="4">
                      <div class="detail-label">เลขบัตรประชาชน</div>
                      <div class="detail-value">{{ selectedApp.supervisor_app_idcard }}</div>
                    </v-col>
                    <v-col cols="6" md="4">
                      <div class="detail-label">ตำแหน่ง</div>
                      <div class="detail-value">{{ selectedApp.supervisor_app_id_position || '-' }}</div>
                    </v-col>
                    <v-col cols="6" md="4">
                      <div class="detail-label">สถานศึกษา</div>
                      <div class="detail-value">{{ selectedApp.supervisor_app_user_firstname }}</div>
                    </v-col>
                    <v-col cols="6" md="4">
                      <div class="detail-label">อายุราชการ</div>
                      <div class="detail-value">{{ selectedApp.supervisor_app_agework || '-' }}</div>
                    </v-col>
                    <v-col cols="6" md="4">
                      <div class="detail-label">ระยะเวลาดำรงตำแหน่ง</div>
                      <div class="detail-value">{{ selectedApp.supervisor_age_position || '-' }}</div>
                    </v-col>
                  </v-row>
                </div>

                <!-- Address -->
                <div class="detail-section mt-4">
                  <div class="detail-section-title">
                    <v-icon small color="#1565c0" class="mr-1">mdi-map-marker-outline</v-icon>
                    ที่อยู่
                  </div>
                  <div class="detail-value mt-2">
                    {{ selectedApp.supervisor_app_address || '' }}
                    {{ selectedApp.supervisor_app_moo ? 'หมู่ ' + selectedApp.supervisor_app_moo : '' }}
                    {{ selectedApp.supervisor_app_soi ? 'ซอย ' + selectedApp.supervisor_app_soi : '' }}
                    {{ selectedApp.supervisor_app_road ? 'ถนน ' + selectedApp.supervisor_app_road : '' }}
                    {{ selectedApp.supervisor_app_subdistrict ? 'ต.' + selectedApp.supervisor_app_subdistrict : '' }}
                    {{ selectedApp.supervisor_app_district ? 'อ.' + selectedApp.supervisor_app_district : '' }}
                    {{ selectedApp.supervisor_app_province ? 'จ.' + selectedApp.supervisor_app_province : '' }}
                    {{ selectedApp.supervisor_app_zipcode || '' }}
                  </div>
                </div>

                <!-- Contact -->
                <div class="detail-section mt-4">
                  <div class="detail-section-title">
                    <v-icon small color="#1565c0" class="mr-1">mdi-phone-outline</v-icon>
                    ข้อมูลติดต่อ
                  </div>
                  <v-row dense class="mt-2">
                    <v-col cols="6" md="3">
                      <div class="detail-label">มือถือ</div>
                      <div class="detail-value">{{ selectedApp.supervisor_app_tel_mobile || '-' }}</div>
                    </v-col>
                    <v-col cols="6" md="3">
                      <div class="detail-label">ที่ทำงาน</div>
                      <div class="detail-value">{{ selectedApp.supervisor_app_tel_office || '-' }}</div>
                    </v-col>
                    <v-col cols="6" md="3">
                      <div class="detail-label">บ้าน</div>
                      <div class="detail-value">{{ selectedApp.supervisor_app_tel_home || '-' }}</div>
                    </v-col>
                    <v-col cols="6" md="3">
                      <div class="detail-label">E-mail</div>
                      <div class="detail-value">{{ selectedApp.supervisor_app_email || '-' }}</div>
                    </v-col>
                  </v-row>
                </div>

                <!-- Documents Checklist -->
                <div class="detail-section mt-4">
                  <div class="detail-section-title">
                    <v-icon small color="#1565c0" class="mr-1">mdi-file-document-multiple-outline</v-icon>
                    หลักฐานที่แนบ
                  </div>
                  <v-row dense class="mt-2">
                    <v-col cols="12" md="6" v-for="doc in documentList" :key="doc.field">
                      <div class="d-flex align-center py-1">
                        <v-icon
                          size="18"
                          :color="selectedApp[doc.field] === '1' || selectedApp[doc.field] === 1 ? '#2e7d32' : '#bdbdbd'"
                          class="mr-2"
                        >
                          {{ selectedApp[doc.field] === '1' || selectedApp[doc.field] === 1 ? 'mdi-check-circle' : 'mdi-checkbox-blank-circle-outline' }}
                        </v-icon>
                        <span
                          class="text-body-2"
                          :class="selectedApp[doc.field] === '1' || selectedApp[doc.field] === 1 ? 'grey--text text--darken-3' : 'grey--text'"
                        >
                          {{ doc.number }} {{ doc.label }}
                          <span v-if="doc.required" class="red--text">*</span>
                        </span>
                      </div>
                    </v-col>
                  </v-row>
                </div>

                <!-- Discipline -->
                <div class="detail-section mt-4">
                  <div class="detail-section-title">
                    <v-icon small color="#1565c0" class="mr-1">mdi-shield-check-outline</v-icon>
                    การรักษาวินัย
                  </div>
                  <div class="mt-2">
                    <v-chip
                      :color="selectedApp.supervisor_app_discipline === 'never' || selectedApp.supervisor_app_discipline === '0' ? '#2e7d32' : '#ef6c00'"
                      small dark
                    >
                      {{ selectedApp.supervisor_app_discipline === 'never' || selectedApp.supervisor_app_discipline === '0' ? 'ไม่เคยถูกลงโทษ' : 'เคยถูกลงโทษทางวินัย' }}
                    </v-chip>
                  </div>
                </div>
              </v-card>
            </v-col>

            <!-- Right: Actions -->
            <v-col cols="12" md="4">
              <!-- Approve Card -->
              <v-card flat class="rounded-lg card-white pa-5 mb-4">
                <div class="card-title-text mb-3">พิจารณาอนุมัติ</div>
                <v-radio-group v-model="approveForm.result" column class="mt-0">
                  <v-radio value="pass" color="#2e7d32">
                    <template v-slot:label>
                      <span class="font-weight-bold green--text text--darken-3">ผ่านคุณสมบัติ</span>
                    </template>
                  </v-radio>
                  <v-radio value="fail" color="#c62828">
                    <template v-slot:label>
                      <span class="font-weight-bold red--text text--darken-3">ไม่ผ่านคุณสมบัติ</span>
                    </template>
                  </v-radio>
                </v-radio-group>
                <v-textarea
                  v-model="approveForm.note"
                  label="หมายเหตุ"
                  outlined dense rows="3"
                  background-color="#f8f9fb"
                  class="mt-1"
                ></v-textarea>
                <v-btn
                  block
                  :color="approveForm.result === 'pass' ? '#2e7d32' : '#c62828'"
                  dark
                  :disabled="!approveForm.result"
                  @click="submitApproval()"
                  class="text-none mt-1"
                >
                  <v-icon left>mdi-check-decagram</v-icon>
                  บันทึกผลการพิจารณา
                </v-btn>
              </v-card>

              <!-- Print Card -->
              <v-card flat class="rounded-lg card-white pa-5 mb-4">
                <div class="card-title-text mb-3">พิมพ์เอกสาร</div>
                <v-btn block outlined color="#1565c0" @click="openPrintDialog(selectedApp.supervisor_app_idref)" class="mb-2 text-none">
                  <v-icon left>mdi-printer-outline</v-icon> พิมพ์ใบสมัคร
                </v-btn>
              </v-card>

              <!-- Timeline Card -->
              <v-card flat class="rounded-lg card-white pa-5">
                <div class="card-title-text mb-3">ประวัติขั้นตอน</div>
                <v-timeline dense align-top>
                  <v-timeline-item
                    v-for="(step, i) in getTimeline(selectedApp)"
                    :key="i"
                    :color="step.active ? step.color : '#e0e0e0'"
                    small
                    fill-dot
                  >
                    <div :class="step.active ? '' : 'grey--text text--lighten-1'">
                      <div class="text-body-2 font-weight-medium">{{ step.title }}</div>
                      <div class="text-caption grey--text">{{ step.desc }}</div>
                    </div>
                  </v-timeline-item>
                </v-timeline>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>

      <!-- ==================== TAB: STATISTICS ==================== -->
      <v-tab-item>
        <v-container fluid class="pa-5">
          <v-row>
            <v-col cols="12">
              <v-card flat class="rounded-lg card-white">
                <v-card-title class="card-header">
                  <div>
                    <div class="card-title-text">สถิติการสมัครตามสถานศึกษา</div>
                    <div class="card-subtitle-text">แสดงจำนวนผู้สมัครแยกตามสถานศึกษาต้นสังกัด</div>
                  </div>
                </v-card-title>
                <v-card-text>
                  <canvas ref="collegeChart" height="320"></canvas>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row class="mt-2">
            <v-col cols="12" md="6">
              <v-card flat class="rounded-lg card-white">
                <v-card-title class="card-header">
                  <div class="card-title-text">อัตราการยืนยันสมัคร</div>
                </v-card-title>
                <v-card-text>
                  <canvas ref="completionChart" height="280"></canvas>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="6">
              <v-card flat class="rounded-lg card-white">
                <v-card-title class="card-header">
                  <div class="card-title-text">ผลการอนุมัติคุณสมบัติ</div>
                </v-card-title>
                <v-card-text>
                  <canvas ref="approvalChart" height="280"></canvas>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row class="mt-2">
            <v-col cols="12">
              <v-card flat class="rounded-lg card-white">
                <v-card-title class="card-header">
                  <div class="card-title-text">สรุปข้อมูลตามจังหวัด</div>
                </v-card-title>
                <v-data-table
                  :headers="provinceHeaders"
                  :items="provinceStats"
                  class="white-data-table"
                  :items-per-page="10"
                  dense
                >
                  <template v-slot:item.pass_rate="{ item }">
                    <v-progress-linear
                      :value="item.pass_rate"
                      :color="item.pass_rate >= 80 ? '#2e7d32' : item.pass_rate >= 50 ? '#ef6c00' : '#c62828'"
                      height="18"
                      rounded
                      class="my-1"
                      background-color="#f0f0f0"
                    >
                      <span class="text-caption white--text font-weight-bold">{{ item.pass_rate }}%</span>
                    </v-progress-linear>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>

      <!-- ==================== TAB: COLLEGES ==================== -->
      <v-tab-item>
        <v-container fluid class="pa-5">
          <v-card flat class="rounded-lg card-white">
            <v-card-title class="card-header">
              <div>
                <div class="card-title-text">จัดการสถานศึกษา / หน่วยรับสมัคร</div>
                <div class="card-subtitle-text">ตรวจสอบสถานะการดำเนินงานของแต่ละสถานศึกษา</div>
              </div>
            </v-card-title>
            <v-data-table
              :headers="collegeHeaders"
              :items="collegeData"
              :loading="loadingColleges"
              class="white-data-table"
              :items-per-page="15"
            >
              <template v-slot:item.total="{ item }">
                <span class="font-weight-bold" style="color: #1565c0;">{{ item.total }}</span>
              </template>
              <template v-slot:item.confirmed="{ item }">
                <v-chip x-small :color="item.confirmed > 0 ? '#2e7d32' : '#bdbdbd'" dark>{{ item.confirmed }}</v-chip>
              </template>
              <template v-slot:item.pending="{ item }">
                <v-chip x-small :color="item.pending > 0 ? '#ef6c00' : '#bdbdbd'" dark>{{ item.pending }}</v-chip>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon x-small color="#1565c0" @click="viewCollegeApps(item)">
                  <v-icon size="18">mdi-eye-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card>
        </v-container>
      </v-tab-item>

      <!-- ==================== TAB: SETTINGS ==================== -->
      <v-tab-item>
        <v-container fluid class="pa-5">
          <v-row>
            <v-col cols="12" md="6">
              <v-card flat class="rounded-lg card-white pa-5">
                <div class="card-title-text mb-4">ตั้งค่ารอบการรับสมัคร</div>
                <v-text-field v-model="settings.year" label="ปี (พ.ศ.)" outlined dense background-color="#f8f9fb"></v-text-field>
                <v-text-field v-model="settings.time" label="ครั้งที่" outlined dense background-color="#f8f9fb"></v-text-field>
                <v-menu v-model="menuStart" :close-on-content-click="false" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="settings.startDate" label="วันเริ่มรับสมัคร"
                      prepend-inner-icon="mdi-calendar" readonly outlined dense
                      background-color="#f8f9fb" v-bind="attrs" v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="settings.startDate" @input="menuStart = false"></v-date-picker>
                </v-menu>
                <v-menu v-model="menuEnd" :close-on-content-click="false" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="settings.endDate" label="วันสิ้นสุดรับสมัคร"
                      prepend-inner-icon="mdi-calendar" readonly outlined dense
                      background-color="#f8f9fb" v-bind="attrs" v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="settings.endDate" @input="menuEnd = false"></v-date-picker>
                </v-menu>
                <v-switch v-model="settings.enabled" label="เปิดรับสมัคร" color="#1565c0" inset></v-switch>
                <v-btn color="#1565c0" dark block class="text-none" @click="saveSettings()">
                  <v-icon left>mdi-content-save</v-icon> บันทึกการตั้งค่า
                </v-btn>
              </v-card>
            </v-col>
            <v-col cols="12" md="6">
              <v-card flat class="rounded-lg card-white pa-5">
                <div class="card-title-text mb-4">ประกาศผลคัดเลือก</div>
                <v-textarea v-model="settings.announcement" label="ข้อความประกาศ" outlined rows="5" background-color="#f8f9fb"></v-textarea>
                <v-switch v-model="settings.showAnnouncement" label="แสดงประกาศ" color="#1565c0" inset></v-switch>
                <v-btn color="#1565c0" dark block class="text-none" @click="saveAnnouncement()">
                  <v-icon left>mdi-bullhorn-outline</v-icon> เผยแพร่ประกาศ
                </v-btn>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>
    </v-tabs-items>

    <!-- ==================== APPROVE DIALOG ==================== -->
    <v-dialog v-model="approveDialog" max-width="520" persistent>
      <v-card class="rounded-lg">
        <v-card-title class="pa-4 d-flex align-center">
          <v-icon color="#1565c0" class="mr-2">mdi-check-decagram</v-icon>
          <span class="card-title-text">พิจารณาอนุมัติ</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-5">
          <div class="text-body-1 mb-3">
            ผู้สมัคร: <strong>{{ dialogApp.supervisor_app_fristnames }}</strong>
          </div>
          <v-radio-group v-model="approveForm.result" column class="mt-0">
            <v-radio value="pass" color="#2e7d32">
              <template v-slot:label><span class="font-weight-bold green--text text--darken-3">ผ่านคุณสมบัติ</span></template>
            </v-radio>
            <v-radio value="fail" color="#c62828">
              <template v-slot:label><span class="font-weight-bold red--text text--darken-3">ไม่ผ่านคุณสมบัติ</span></template>
            </v-radio>
          </v-radio-group>
          <v-textarea v-model="approveForm.note" label="หมายเหตุ" outlined dense rows="3" background-color="#f8f9fb"></v-textarea>
        </v-card-text>
        <v-card-actions class="pa-4 pt-0">
          <v-spacer></v-spacer>
          <v-btn text @click="approveDialog = false" class="text-none">ยกเลิก</v-btn>
          <v-btn
            :color="approveForm.result === 'pass' ? '#2e7d32' : '#c62828'"
            dark :disabled="!approveForm.result"
            @click="submitApprovalDialog()" class="text-none"
          >บันทึก</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Print Dialog -->
    <v-dialog v-model="printDialog" max-width="1000" scrollable>
      <v-card>
        <v-card-title class="primary white--text pa-4">
          <v-icon color="white" class="mr-2">mdi-printer</v-icon>
          ใบสมัครศึกษานิเทศก์
          <v-spacer></v-spacer>
          <v-btn icon color="white" @click="printDialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="pa-0" style="height: 80vh; overflow: hidden;">
          <iframe v-if="pdfSrc" :src="pdfSrc" width="100%" height="100%" style="border: none;"></iframe>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
  </div>

</template>

<script>
import Supervision_app_bar from '../../components/admin/supervision_app_bar.vue';

export default {
  name: "AdminSupervisorDashboard",
  components: { Supervision_app_bar },
  data() {
    return {
      ApiKey: "HRvec2021",
      loading: false,
      loadingApps: false,
      loadingColleges: false,
      currentTab: 0,
      chartPeriod: "14d",

      tabs: [
        { title: "แดชบอร์ด", icon: "mdi-view-dashboard-outline", value: 0 },
        { title: "รายการใบสมัคร", icon: "mdi-file-document-outline", value: 1, badge: null },
        { title: "รายละเอียด", icon: "mdi-account-details-outline", value: 2 },
        { title: "สถิติและรายงาน", icon: "mdi-chart-bar", value: 3 },
        { title: "สถานศึกษา", icon: "mdi-domain", value: 4 },
        { title: "ตั้งค่า", icon: "mdi-cog-outline", value: 5 },
      ],

      // Dashboard
      statsCards: [
        { title: "ผู้สมัครทั้งหมด", value: "0", sub: "รายการ", icon: "mdi-account-group", color: "#1565c0" },
        { title: "ยืนยันแล้ว", value: "0", sub: "รายการ", icon: "mdi-check-circle", color: "#2e7d32" },
        { title: "รอตรวจสอบ", value: "0", sub: "รายการ", icon: "mdi-clock-outline", color: "#ef6c00" },
        { title: "อนุมัติแล้ว", value: "0", sub: "รายการ", icon: "mdi-check-decagram", color: "#c62828" },
      ],
      recentApps: [],

      // Applications
      applications: [],
      selectedApps: [],
      filters: { search: "", status: null, approve: null, region: null, dateRange: null },
      dateRangeMenu: false,
      appHeaders: [
        { text: "เลขที่สมัคร", value: "supervisor_app_idno", width: "120" },
        { text: "ชื่อ-สกุล", value: "supervisor_app_fristnames", width: "220" },
        { text: "สถานศึกษา", value: "supervisor_app_user_firstname", width: "200" },
        { text: "สถานะ", value: "supervisor_app_status", width: "110", align: "center" },
        { text: "ผลอนุมัติ", value: "supervisor_app_approve", width: "110", align: "center" },
        { text: "วันที่สมัคร", value: "supervisor_app_created_at", width: "120" },
        { text: "จัดการ", value: "actions", sortable: false, width: "130", align: "center" },
      ],
      statusFilterItems: [
        { text: "สร้างใบสมัคร", value: "1" }, { text: "กรอกที่อยู่", value: "2" },
        { text: "ตรวจวุฒิ", value: "3" }, { text: "ตรวจตำแหน่ง", value: "4" },
        { text: "ข้อมูลติดต่อ", value: "5" }, { text: "วินัย", value: "6" },
        { text: "ยืนยันแล้ว", value: "7" }, { text: "ดำเนินการเสร็จ", value: "8" },
      ],
      approveFilterItems: [
        { text: "ผ่าน", value: "pass" }, { text: "ไม่ผ่าน", value: "fail" }, { text: "รอตรวจสอบ", value: "pending" },
      ],
      regionFilterItems: [
        { text: "ภาคเหนือ", value: "north" }, { text: "ภาคกลาง", value: "central" },
        { text: "ภาคตะวันออกเฉียงเหนือ", value: "northeast" }, { text: "ภาคใต้", value: "south" },
        { text: "ภาคตะวันออก", value: "east" }, { text: "ภาคตะวันตก", value: "west" },
      ],

      // Detail & Approve
      selectedApp: {},
      approveForm: { result: null, note: "" },
      approveDialog: false,
      dialogApp: {},

      // Print
      printDialog: false,
      pdfSrc: "",

      // Statistics
      provinceHeaders: [
        { text: "จังหวัด", value: "province" },
        { text: "จำนวนผู้สมัคร", value: "total", align: "center" },
        { text: "ยืนยันแล้ว", value: "confirmed", align: "center" },
        { text: "ผ่าน", value: "passed", align: "center" },
        { text: "ไม่ผ่าน", value: "failed", align: "center" },
        { text: "อัตราผ่าน", value: "pass_rate", width: "200" },
      ],
      provinceStats: [],

      // College
      collegeHeaders: [
        { text: "รหัส", value: "code", width: "100" },
        { text: "ชื่อสถานศึกษา", value: "name" },
        { text: "จังหวัด", value: "province", width: "120" },
        { text: "ผู้สมัคร", value: "total", align: "center", width: "100" },
        { text: "ยืนยัน", value: "confirmed", align: "center", width: "100" },
        { text: "รอดำเนินการ", value: "pending", align: "center", width: "110" },
        { text: "จัดการ", value: "actions", sortable: false, width: "80", align: "center" },
      ],
      collegeData: [],

      // Settings
      settings: { year: "2568", time: "1", startDate: "", endDate: "", enabled: true, announcement: "", showAnnouncement: false },
      menuStart: false,
      menuEnd: false,

      period_supervisor: {},

      // Document List
      documentList: [
        { number: "6.1", field: "supervisor_app_file_1", label: "สำเนาปริญญาบัตร", required: true },
        { number: "6.2", field: "supervisor_app_file_2", label: "สำเนา Transcript", required: true },
        { number: "6.3", field: "supervisor_app_file_3", label: "สำเนาทะเบียนประวัติ ก.พ.7/ก.ค.ศ.16", required: true },
        { number: "6.4", field: "supervisor_app_file_4", label: "สำเนาทะเบียนบ้าน", required: true },
        { number: "6.5", field: "supervisor_app_file_5", label: "สำเนาบัตรข้าราชการ", required: true },
        { number: "6.6", field: "supervisor_app_file_6", label: "สำเนาบัตรประชาชน", required: true },
        { number: "6.7", field: "supervisor_app_file_7", label: "รูปถ่ายหน้าตรง 1 นิ้ว", required: true },
        { number: "6.8", field: "supervisor_app_file_8", label: "ใบอนุญาตประกอบวิชาชีพศึกษานิเทศก์", required: true },
        { number: "6.9", field: "supervisor_app_file_9", label: "แบบเสนอชื่อ (ถ้ามี)", required: false },
        { number: "6.10", field: "supervisor_app_file_10", label: "ประวัติผู้นำทางวิชาการ", required: true },
        { number: "6.11", field: "supervisor_app_file_11", label: "วิสัยทัศน์ศึกษานิเทศก์", required: true },
        { number: "6.12", field: "supervisor_app_file_12", label: "ผลงาน/รางวัล", required: true },
        { number: "6.13", field: "supervisor_app_file_13", label: "แผนการนิเทศ", required: true },
        { number: "6.14", field: "supervisor_app_file_14", label: "หลักฐานอื่นๆ (ถ้ามี)", required: false },
      ],
    };
  },

  computed: {
    filteredApplications() {
      let data = [...this.applications];
      if (this.filters.search) {
        const s = this.filters.search.toLowerCase();
        data = data.filter(a =>
          (a.supervisor_app_fristnames || "").toLowerCase().includes(s) ||
          (a.supervisor_app_idcard || "").includes(s) ||
          (a.supervisor_app_idno || "").includes(s) ||
          (a.supervisor_app_idref || "").includes(s)
        );
      }
      if (this.filters.status) data = data.filter(a => a.supervisor_app_status === this.filters.status);
      if (this.filters.approve) {
        if (this.filters.approve === "pending") data = data.filter(a => !a.supervisor_app_approve);
        else data = data.filter(a => a.supervisor_app_approve === this.filters.approve);
      }
      return data;
    },
  },

  async mounted() {
    await this.periodSupervisorQuery();
    await this.loadApplications();
    this.updateStats();
    this.$nextTick(() => { this.initCharts(); });
  },

  methods: {
    async periodSupervisorQuery() {
      let result = await this.$http.post("period_sedirector.php", {
        ApiKey: this.ApiKey, period_sedirector_enable: "1", period_sedirector_id: "402"
      });
      this.period_supervisor = result.data;
    },

    async loadApplications() {
      this.loadingApps = true;
      try {
        let result = await this.$http.post("supervisor_app.php", {
          ApiKey: this.ApiKey,
          supervisor_app_year: this.period_supervisor.period_sedirector_year,
          supervisor_app_time: this.period_supervisor.period_sedirector_times,
        });
        this.applications = Array.isArray(result.data) ? result.data : [];
        this.recentApps = this.applications.slice(0, 8);
        this.updateStats();
      } catch (e) { console.error("Error loading:", e); }
      finally { this.loadingApps = false; }
    },

    updateStats() {
      const apps = this.applications;
      this.statsCards[0].value = apps.length.toString();
      this.statsCards[1].value = apps.filter(a => parseInt(a.supervisor_app_status) >= 7).length.toString();
      this.statsCards[2].value = apps.filter(a => parseInt(a.supervisor_app_status) < 7).length.toString();
      this.statsCards[3].value = apps.filter(a => a.supervisor_app_approve === "pass").length.toString();
      const pending = apps.filter(a => parseInt(a.supervisor_app_status) >= 7 && !a.supervisor_app_approve).length;
      this.tabs[1].badge = pending > 0 ? pending.toString() : null;
      this.computeProvinceStats();
    },

    computeProvinceStats() {
      const map = {};
      this.applications.forEach(a => {
        const prov = a.supervisor_app_province || "ไม่ระบุ";
        if (!map[prov]) map[prov] = { province: prov, total: 0, confirmed: 0, passed: 0, failed: 0 };
        map[prov].total++;
        if (parseInt(a.supervisor_app_status) >= 7) map[prov].confirmed++;
        if (a.supervisor_app_approve === "pass") map[prov].passed++;
        if (a.supervisor_app_approve === "fail") map[prov].failed++;
      });
      this.provinceStats = Object.values(map).map(p => ({
        ...p, pass_rate: p.total > 0 ? Math.round((p.passed / p.total) * 100) : 0,
      }));
    },

    // ===================== CHARTS =====================
    initCharts() {
      this.initDailyChart();
      this.initStatusChart();
      this.initRegionChart();
    },

    initDailyChart() {
      const canvas = this.$refs.dailyChart;
      if (!canvas) return;
      const ctx = canvas.getContext("2d");
      const labels = [], data = [];
      for (let i = 13; i >= 0; i--) {
        const d = new Date(); d.setDate(d.getDate() - i);
        labels.push(d.toLocaleDateString("th-TH", { day: "numeric", month: "short" }));
        data.push(Math.floor(Math.random() * 20) + 3);
      }
      if (this.applications.length > 0) {
        const dateMap = {};
        this.applications.forEach(a => {
          if (a.supervisor_app_created_at) {
            const key = a.supervisor_app_created_at.substring(0, 10);
            dateMap[key] = (dateMap[key] || 0) + 1;
          }
        });
      }
      new Chart(ctx, {
        type: "bar",
        data: {
          labels,
          datasets: [{
            label: "จำนวนผู้สมัคร", data,
            backgroundColor: "rgba(21,101,192,0.65)", borderColor: "#1565c0",
            borderWidth: 1, borderRadius: 4, barPercentage: 0.55,
          }],
        },
        options: {
          responsive: true, maintainAspectRatio: false,
          plugins: { legend: { display: false } },
          scales: {
            x: { grid: { color: "#f0f0f0" }, ticks: { color: "#888", font: { size: 11 } } },
            y: { grid: { color: "#f0f0f0" }, ticks: { color: "#888", font: { size: 11 } }, beginAtZero: true },
          },
        },
      });
    },

    initStatusChart() {
      const canvas = this.$refs.statusChart;
      if (!canvas) return;
      const ctx = canvas.getContext("2d");
      const sc = [0, 0, 0, 0, 0, 0, 0, 0];
      this.applications.forEach(a => { const s = parseInt(a.supervisor_app_status) - 1; if (s >= 0 && s < 8) sc[s]++; });
      new Chart(ctx, {
        type: "doughnut",
        data: {
          labels: ["สร้างใบสมัคร", "ที่อยู่", "วุฒิ", "ตำแหน่ง", "ติดต่อ", "วินัย", "ยืนยัน", "เสร็จสิ้น"],
          datasets: [{
            data: sc.some(c => c > 0) ? sc : [5, 8, 12, 10, 7, 15, 30, 20],
            backgroundColor: ["#1565c0", "#42a5f5", "#ef6c00", "#ffa726", "#26a69a", "#7e57c2", "#2e7d32", "#66bb6a"],
            borderWidth: 0,
          }],
        },
        options: {
          responsive: true, maintainAspectRatio: false, cutout: "62%",
          plugins: { legend: { position: "bottom", labels: { color: "#666", font: { size: 10 }, padding: 8, boxWidth: 12 } } },
        },
      });
    },

    initRegionChart() {
      const canvas = this.$refs.regionChart;
      if (!canvas) return;
      const ctx = canvas.getContext("2d");
      new Chart(ctx, {
        type: "polarArea",
        data: {
          labels: ["ภาคเหนือ", "ภาคกลาง", "ภาคอีสาน", "ภาคใต้", "ภาคตะวันออก", "ภาคตะวันตก"],
          datasets: [{
            data: [18, 35, 25, 12, 8, 6],
            backgroundColor: [
              "rgba(21,101,192,0.6)", "rgba(46,125,50,0.6)", "rgba(239,108,0,0.6)",
              "rgba(198,40,40,0.6)", "rgba(126,87,194,0.6)", "rgba(66,165,245,0.6)",
            ],
            borderWidth: 0,
          }],
        },
        options: {
          responsive: true, maintainAspectRatio: false,
          plugins: { legend: { position: "bottom", labels: { color: "#666", font: { size: 10 }, padding: 8, boxWidth: 12 } } },
          scales: { r: { grid: { color: "#eee" }, ticks: { display: false } } },
        },
      });
    },

    // ===================== APPROVAL =====================
    openApproveDialog(item) {
      this.dialogApp = item;
      this.approveForm = { result: item.supervisor_app_approve || null, note: item.supervisor_app_approve_note || "" };
      this.approveDialog = true;
    },
    async submitApprovalDialog() { await this.submitApprovalFor(this.dialogApp); this.approveDialog = false; },
    async submitApproval() { await this.submitApprovalFor(this.selectedApp); },
    async submitApprovalFor(app) {
      try {
        let result = await this.$http.post("supervisor_app.update.php", {
          ApiKey: this.ApiKey,
          supervisor_app_idref: app.supervisor_app_idref,
          supervisor_app_approve: this.approveForm.result,
          supervisor_app_approve_note: this.approveForm.note,
        });
        if (result.data.status === true) {
          Swal.fire({ title: "บันทึกผลเรียบร้อย", icon: "success", showConfirmButton: false, timer: 1500 });
          await this.loadApplications();
        } else {
          Swal.fire({ icon: "warning", title: "เกิดข้อผิดพลาด", showConfirmButton: false, timer: 1500 });
        }
      } catch (e) { Swal.fire({ icon: "error", title: "ไม่สามารถบันทึกได้", timer: 1500, showConfirmButton: false }); }
    },
    async bulkApprove(result) {
      const count = this.selectedApps.length;
      const label = result === "pass" ? "อนุมัติ" : "ไม่อนุมัติ";
      const confirm = await Swal.fire({
        title: `${label} ${count} รายการ`, text: `ต้องการ${label}ผู้สมัครที่เลือกทั้งหมดใช่หรือไม่?`,
        icon: "warning", showCancelButton: true, confirmButtonText: "ยืนยัน", cancelButtonText: "ยกเลิก",
      });
      if (confirm.isConfirmed) {
        for (const app of this.selectedApps) {
          await this.$http.post("supervisor_app.update.php", {
            ApiKey: this.ApiKey, supervisor_app_idref: app.supervisor_app_idref, supervisor_app_approve: result,
          });
        }
        this.selectedApps = [];
        await this.loadApplications();
        Swal.fire({ title: "ดำเนินการเรียบร้อย", icon: "success", timer: 1500, showConfirmButton: false });
      }
    },

    // ===================== NAVIGATION =====================
    viewApplication(item) {
      this.selectedApp = item;
      this.approveForm = { result: item.supervisor_app_approve || null, note: item.supervisor_app_approve_note || "" };
      this.currentTab = 2; // detail tab
    },
    viewCollegeApps(college) { this.filters.search = college.code; this.currentTab = 1; },

    // ===================== PRINT =====================
    openPrintDialog(idref) {
      let baseURL = this.$http.defaults.baseURL || "";
      this.pdfSrc = `${baseURL}print_app_supervisor.php?id=${idref}`;
      this.printDialog = true;
    },

    // ===================== EXPORT =====================
    exportExcel() {
      let csv = "\uFEFF";
      csv += "เลขที่สมัคร,ชื่อ-สกุล,เลขบัตรประชาชน,สถานศึกษา,สถานะ,ผลอนุมัติ,วันที่สมัคร\n";
      this.filteredApplications.forEach(a => {
        csv += `"${a.supervisor_app_idno || ""}","${a.supervisor_app_fristnames || ""}","${a.supervisor_app_idcard || ""}","${a.supervisor_app_user_firstname || ""}","${this.getStatusText(a.supervisor_app_status)}","${a.supervisor_app_approve === "pass" ? "ผ่าน" : a.supervisor_app_approve === "fail" ? "ไม่ผ่าน" : "รอ"}","${a.supervisor_app_created_at || ""}"\n`;
      });
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `supervisor_apps_export.csv`;
      link.click();
      URL.revokeObjectURL(url);
    },

    // ===================== SETTINGS =====================
    async saveSettings() {
      try {
        let result = await this.$http.post("period_sedirector.update.php", {
          ApiKey: this.ApiKey, period_sedirector_year: this.settings.year, period_sedirector_times: this.settings.time,
          period_sedirector_start: this.settings.startDate, period_sedirector_stop: this.settings.endDate,
          period_sedirector_enable: this.settings.enabled ? "1" : "0",
        });
        if (result.data.status) Swal.fire({ title: "บันทึกเรียบร้อย", icon: "success", timer: 1500, showConfirmButton: false });
      } catch (e) { Swal.fire({ icon: "error", title: "ผิดพลาด", timer: 1500, showConfirmButton: false }); }
    },
    async saveAnnouncement() { Swal.fire({ title: "บันทึกประกาศเรียบร้อย", icon: "success", timer: 1500, showConfirmButton: false }); },

    // ===================== HELPERS =====================
    getStatusText(status) {
      const m = { "0": "เริ่มต้น", "1": "สร้างใบสมัคร", "2": "กรอกที่อยู่", "3": "ตรวจวุฒิ", "4": "ตรวจตำแหน่ง", "5": "ข้อมูลติดต่อ", "6": "วินัย", "7": "ยืนยันแล้ว", "8": "เสร็จสิ้น" };
      return m[String(status)] || "ไม่ทราบ";
    },
    getStatusColor(status) {
      const m = { "0": "#9e9e9e", "1": "#1565c0", "2": "#42a5f5", "3": "#ef6c00", "4": "#ffa726", "5": "#26a69a", "6": "#7e57c2", "7": "#2e7d32", "8": "#66bb6a" };
      return m[String(status)] || "#9e9e9e";
    },
    formatDate(dateStr) {
      if (!dateStr) return "-";
      try { return new Date(dateStr).toLocaleDateString("th-TH", { day: "numeric", month: "short", year: "2-digit" }); }
      catch { return dateStr; }
    },
    getTimeline(app) {
      const s = parseInt(app.supervisor_app_status) || 0;
      return [
        { title: "สร้างใบสมัคร", desc: "ตรวจสอบข้อมูลพื้นฐาน", color: "#1565c0", active: s >= 1 },
        { title: "กรอกที่อยู่", desc: "ข้อมูลที่อยู่ปัจจุบัน", color: "#42a5f5", active: s >= 2 },
        { title: "ตรวจวุฒิการศึกษา", desc: "คุณวุฒิการศึกษา", color: "#ef6c00", active: s >= 3 },
        { title: "ตรวจตำแหน่ง", desc: "ตำแหน่งปัจจุบัน", color: "#ffa726", active: s >= 4 },
        { title: "ข้อมูลติดต่อ", desc: "สถานที่ติดต่อ", color: "#26a69a", active: s >= 5 },
        { title: "การรักษาวินัย", desc: "ข้อมูลวินัย", color: "#7e57c2", active: s >= 6 },
        { title: "ยืนยันการสมัคร", desc: app.supervisor_app_datetime || "", color: "#2e7d32", active: s >= 7 },
        { title: "ดำเนินการเสร็จ", desc: "ประกาศผล", color: "#66bb6a", active: s >= 8 },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
/* ==================== HEADER ==================== */
.header-bar {
  border-bottom: 1px solid #e8ecf1;
}
.page-title {
  font-size: 18px;
  font-weight: 700;
  color: #1a237e;
  letter-spacing: -0.3px;
}
.page-subtitle {
  font-size: 13px;
  color: #78909c;
}
.chip-period {
  font-size: 12px;
  letter-spacing: 0.2px;
}

/* ==================== TABS ==================== */
.tab-item {
  font-size: 13px !important;
  font-weight: 500;
  letter-spacing: 0.2px;
}
.tab-content-area {
  background: #f5f6fa;
  min-height: calc(100vh - 180px);
}

/* ==================== STAT CARDS ==================== */
.stat-card {
  background: #ffffff;
  border: 1px solid #e8ecf1;
  transition: box-shadow 0.2s ease;
  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08) !important;
  }
}
.stat-card-label {
  font-size: 12px;
  color: #78909c;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}
.stat-card-value {
  font-size: 30px;
  font-weight: 800;
  line-height: 1.2;
  margin-top: 2px;
}
.stat-card-sub {
  font-size: 12px;
  color: #b0bec5;
}
.stat-icon-avatar {
  opacity: 0.9;
}

/* ==================== CARDS ==================== */
.card-white {
  background: #ffffff !important;
  border: 1px solid #e8ecf1 !important;
}
.card-header {
  padding: 16px 20px 8px;
}
.card-title-text {
  font-size: 15px;
  font-weight: 700;
  color: #263238;
}
.card-subtitle-text {
  font-size: 12px;
  color: #90a4ae;
  margin-top: 1px;
}

/* ==================== TABLES ==================== */
.white-table {
  background: transparent !important;
  th {
    color: #78909c !important;
    font-size: 11px !important;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 1px solid #e8ecf1 !important;
    background: #fafbfc !important;
  }
  td {
    color: #37474f !important;
    border-bottom: 1px solid #f0f2f5 !important;
    font-size: 13px;
  }
  tr:hover td {
    background: #f5f8ff !important;
  }
}

.white-data-table {
  background: transparent !important;
  ::v-deep th {
    background: #fafbfc !important;
    color: #78909c !important;
    font-size: 11px !important;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 1px solid #e8ecf1 !important;
  }
  ::v-deep td {
    color: #37474f !important;
    border-bottom: 1px solid #f0f2f5 !important;
    font-size: 13px;
  }
  ::v-deep tr:hover td {
    background: #f5f8ff !important;
  }
  ::v-deep .v-data-footer {
    border-top: 1px solid #e8ecf1;
  }
}

/* ==================== PERIOD TOGGLE ==================== */
.period-toggle {
  .v-btn {
    font-size: 12px !important;
    color: #90a4ae !important;
    &.v-btn--active {
      color: #1565c0 !important;
      background: #e3f2fd !important;
    }
  }
}

/* ==================== BULK BAR ==================== */
.bulk-bar {
  background: #e3f2fd;
  border-top: 1px solid #bbdefb;
}

/* ==================== DETAIL ==================== */
.detail-section {
  padding: 14px 16px;
  background: #fafbfc;
  border-radius: 8px;
  border: 1px solid #e8ecf1;
}
.detail-section-title {
  color: #1565c0;
  font-size: 13px;
  font-weight: 600;
  display: flex;
  align-items: center;
}
.detail-label {
  color: #90a4ae;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
.detail-value {
  color: #263238;
  font-size: 14px;
  font-weight: 500;
  margin-top: 2px;
}

/* ==================== BUTTONS ==================== */
.btn-action {
  letter-spacing: 0.2px;
}
</style>